module.exports = __webpack_public_path__ + "static/media/promocodeSM.53d00fdb.svg";